/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Vault (HCV)
 * API for managing HashiCorp Cloud Vault clusters.
 *
 * The version of the OpenAPI document: 20201125
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVault20201125AddPluginRequestToJSON, HashicorpCloudVault20201125CreateRequestToJSON, HashicorpCloudVault20201125CreateResponseFromJSON, HashicorpCloudVault20201125CreateSnapshotRequestToJSON, HashicorpCloudVault20201125CreateSnapshotResponseFromJSON, HashicorpCloudVault20201125DeletePathsFilterResponseFromJSON, HashicorpCloudVault20201125DeletePluginRequestToJSON, HashicorpCloudVault20201125DeleteResponseFromJSON, HashicorpCloudVault20201125DeleteSentinelPolicyRequestToJSON, HashicorpCloudVault20201125DeleteSentinelPolicyResponseFromJSON, HashicorpCloudVault20201125DeleteSnapshotResponseFromJSON, HashicorpCloudVault20201125DeregisterLinkedClusterResponseFromJSON, HashicorpCloudVault20201125FetchAuditLogRequestToJSON, HashicorpCloudVault20201125FetchAuditLogResponseFromJSON, HashicorpCloudVault20201125GetAdminTokenResponseFromJSON, HashicorpCloudVault20201125GetAuditLogStatusResponseFromJSON, HashicorpCloudVault20201125GetAvailableProvidersResponseFromJSON, HashicorpCloudVault20201125GetAvailableTemplatesResponseFromJSON, HashicorpCloudVault20201125GetCORSConfigResponseFromJSON, HashicorpCloudVault20201125GetClientCountsResponseFromJSON, HashicorpCloudVault20201125GetCurrentMilestoneResponseFromJSON, HashicorpCloudVault20201125GetLinkedClusterResponseFromJSON, HashicorpCloudVault20201125GetReplicationStatusResponseFromJSON, HashicorpCloudVault20201125GetResponseFromJSON, HashicorpCloudVault20201125GetSnapshotResponseFromJSON, HashicorpCloudVault20201125GetUtilizationResponseFromJSON, HashicorpCloudVault20201125InputClusterToJSON, HashicorpCloudVault20201125IsVaultPluginRegisteredRequestToJSON, HashicorpCloudVault20201125IsVaultPluginRegisteredResponseFromJSON, HashicorpCloudVault20201125ListAllClustersResponseFromJSON, HashicorpCloudVault20201125ListPerformanceReplicationSecondariesResponseFromJSON, HashicorpCloudVault20201125ListResponseFromJSON, HashicorpCloudVault20201125ListSnapshotsResponseFromJSON, HashicorpCloudVault20201125LockRequestToJSON, HashicorpCloudVault20201125LockResponseFromJSON, HashicorpCloudVault20201125PluginRegistrationStatusResponseFromJSON, HashicorpCloudVault20201125RecreateFromSnapshotRequestToJSON, HashicorpCloudVault20201125RecreateFromSnapshotResponseFromJSON, HashicorpCloudVault20201125RegisterLinkedClusterRequestToJSON, HashicorpCloudVault20201125RegisterLinkedClusterResponseFromJSON, HashicorpCloudVault20201125RestoreSnapshotRequestToJSON, HashicorpCloudVault20201125RestoreSnapshotResponseFromJSON, HashicorpCloudVault20201125RevokeAdminTokensRequestToJSON, HashicorpCloudVault20201125SealRequestToJSON, HashicorpCloudVault20201125SealResponseFromJSON, HashicorpCloudVault20201125UnlockRequestToJSON, HashicorpCloudVault20201125UnlockResponseFromJSON, HashicorpCloudVault20201125UnsealRequestToJSON, HashicorpCloudVault20201125UnsealResponseFromJSON, HashicorpCloudVault20201125UpdateCORSConfigRequestToJSON, HashicorpCloudVault20201125UpdateMajorVersionUpgradeConfigRequestToJSON, HashicorpCloudVault20201125UpdatePathsFilterRequestToJSON, HashicorpCloudVault20201125UpdatePathsFilterResponseFromJSON, HashicorpCloudVault20201125UpdatePublicIpsRequestToJSON, HashicorpCloudVault20201125UpdatePublicIpsResponseFromJSON, HashicorpCloudVault20201125UpdateResponseFromJSON, HashicorpCloudVault20201125UpdateSnapshotRequestToJSON, HashicorpCloudVault20201125UpdateSnapshotResponseFromJSON, HashicorpCloudVault20201125UpdateVersionRequestToJSON, HashicorpCloudVault20201125UpdateVersionResponseFromJSON, HashicorpCloudVault20201125UpgradeMajorVersionRequestToJSON, HashicorpCloudVault20201125UpgradeMajorVersionResponseFromJSON, } from '../models';
/**
 *
 */
export class VaultServiceApi extends runtime.BaseAPI {
    /**
     */
    async _deleteRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling _delete.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling _delete.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling _delete.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125DeleteResponseFromJSON(jsonValue));
    }
    /**
     */
    async _delete(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this._deleteRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async addPluginRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling addPlugin.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling addPlugin.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling addPlugin.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling addPlugin.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/plugin/add`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125AddPluginRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async addPlugin(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.addPluginRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async createRaw(requestParameters) {
        if (requestParameters.clusterLocationOrganizationId === null || requestParameters.clusterLocationOrganizationId === undefined) {
            throw new runtime.RequiredError('clusterLocationOrganizationId', 'Required parameter requestParameters.clusterLocationOrganizationId was null or undefined when calling create.');
        }
        if (requestParameters.clusterLocationProjectId === null || requestParameters.clusterLocationProjectId === undefined) {
            throw new runtime.RequiredError('clusterLocationProjectId', 'Required parameter requestParameters.clusterLocationProjectId was null or undefined when calling create.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling create.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{cluster.location.organization_id}/projects/{cluster.location.project_id}/clusters`.replace(`{${"cluster.location.organization_id"}}`, encodeURIComponent(String(requestParameters.clusterLocationOrganizationId))).replace(`{${"cluster.location.project_id"}}`, encodeURIComponent(String(requestParameters.clusterLocationProjectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125CreateRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125CreateResponseFromJSON(jsonValue));
    }
    /**
     */
    async create(clusterLocationOrganizationId, clusterLocationProjectId, body) {
        const response = await this.createRaw({ clusterLocationOrganizationId: clusterLocationOrganizationId, clusterLocationProjectId: clusterLocationProjectId, body: body });
        return await response.value();
    }
    /**
     */
    async createSnapshotRaw(requestParameters) {
        if (requestParameters.resourceLocationOrganizationId === null || requestParameters.resourceLocationOrganizationId === undefined) {
            throw new runtime.RequiredError('resourceLocationOrganizationId', 'Required parameter requestParameters.resourceLocationOrganizationId was null or undefined when calling createSnapshot.');
        }
        if (requestParameters.resourceLocationProjectId === null || requestParameters.resourceLocationProjectId === undefined) {
            throw new runtime.RequiredError('resourceLocationProjectId', 'Required parameter requestParameters.resourceLocationProjectId was null or undefined when calling createSnapshot.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createSnapshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{resource.location.organization_id}/projects/{resource.location.project_id}/snapshots`.replace(`{${"resource.location.organization_id"}}`, encodeURIComponent(String(requestParameters.resourceLocationOrganizationId))).replace(`{${"resource.location.project_id"}}`, encodeURIComponent(String(requestParameters.resourceLocationProjectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125CreateSnapshotRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125CreateSnapshotResponseFromJSON(jsonValue));
    }
    /**
     */
    async createSnapshot(resourceLocationOrganizationId, resourceLocationProjectId, body) {
        const response = await this.createSnapshotRaw({ resourceLocationOrganizationId: resourceLocationOrganizationId, resourceLocationProjectId: resourceLocationProjectId, body: body });
        return await response.value();
    }
    /**
     */
    async deletePathsFilterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deletePathsFilter.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deletePathsFilter.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling deletePathsFilter.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/paths-filter/delete`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125DeletePathsFilterResponseFromJSON(jsonValue));
    }
    /**
     */
    async deletePathsFilter(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.deletePathsFilterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async deletePluginRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deletePlugin.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deletePlugin.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling deletePlugin.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling deletePlugin.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/plugin/delete`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125DeletePluginRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deletePlugin(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.deletePluginRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async deleteSentinelPolicyRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deleteSentinelPolicy.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deleteSentinelPolicy.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling deleteSentinelPolicy.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling deleteSentinelPolicy.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/sentinel/policy/delete`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125DeleteSentinelPolicyRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125DeleteSentinelPolicyResponseFromJSON(jsonValue));
    }
    /**
     */
    async deleteSentinelPolicy(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.deleteSentinelPolicyRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async deleteSnapshotRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deleteSnapshot.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deleteSnapshot.');
        }
        if (requestParameters.snapshotId === null || requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling deleteSnapshot.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/snapshots/{snapshot_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"snapshot_id"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125DeleteSnapshotResponseFromJSON(jsonValue));
    }
    /**
     */
    async deleteSnapshot(locationOrganizationId, locationProjectId, snapshotId, locationRegionProvider, locationRegionRegion) {
        const response = await this.deleteSnapshotRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, snapshotId: snapshotId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async deregisterLinkedClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deregisterLinkedCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deregisterLinkedCluster.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling deregisterLinkedCluster.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/link/deregister/{cluster_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125DeregisterLinkedClusterResponseFromJSON(jsonValue));
    }
    /**
     */
    async deregisterLinkedCluster(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.deregisterLinkedClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async disableCORSRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling disableCORS.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling disableCORS.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling disableCORS.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/disable-cors`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async disableCORS(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.disableCORSRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async fetchAuditLogRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling fetchAuditLog.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling fetchAuditLog.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling fetchAuditLog.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling fetchAuditLog.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/auditlog`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125FetchAuditLogRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125FetchAuditLogResponseFromJSON(jsonValue));
    }
    /**
     */
    async fetchAuditLog(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.fetchAuditLogRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async getRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling get.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling get.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling get.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetResponseFromJSON(jsonValue));
    }
    /**
     */
    async get(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getAdminTokenRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getAdminToken.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getAdminToken.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getAdminToken.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/admintoken`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetAdminTokenResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAdminToken(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getAdminTokenRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getAuditLogStatusRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getAuditLogStatus.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getAuditLogStatus.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getAuditLogStatus.');
        }
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId', 'Required parameter requestParameters.logId was null or undefined when calling getAuditLogStatus.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/auditlog/{log_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))).replace(`{${"log_id"}}`, encodeURIComponent(String(requestParameters.logId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetAuditLogStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAuditLogStatus(locationOrganizationId, locationProjectId, clusterId, logId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getAuditLogStatusRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, logId: logId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getAvailableProvidersRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getAvailableProviders.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getAvailableProviders.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/providers`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetAvailableProvidersResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAvailableProviders(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getAvailableProvidersRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getAvailableTemplatesRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getAvailableTemplates.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getAvailableTemplates.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/templates`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetAvailableTemplatesResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAvailableTemplates(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getAvailableTemplatesRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getCORSConfigRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getCORSConfig.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getCORSConfig.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getCORSConfig.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/get-cors-config`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetCORSConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getCORSConfig(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getCORSConfigRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getClientCountsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getClientCounts.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getClientCounts.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getClientCounts.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/clients`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetClientCountsResponseFromJSON(jsonValue));
    }
    /**
     */
    async getClientCounts(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getClientCountsRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getCurrentMilestoneRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getCurrentMilestone.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getCurrentMilestone.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getCurrentMilestone.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/current-milestone`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetCurrentMilestoneResponseFromJSON(jsonValue));
    }
    /**
     */
    async getCurrentMilestone(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getCurrentMilestoneRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getLinkedClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getLinkedCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getLinkedCluster.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getLinkedCluster.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/link/clusters/{cluster_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetLinkedClusterResponseFromJSON(jsonValue));
    }
    /**
     */
    async getLinkedCluster(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getLinkedClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getReplicationStatusRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getReplicationStatus.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getReplicationStatus.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getReplicationStatus.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/replication-status`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetReplicationStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async getReplicationStatus(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getReplicationStatusRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getSnapshotRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getSnapshot.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getSnapshot.');
        }
        if (requestParameters.snapshotId === null || requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling getSnapshot.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/snapshots/{snapshot_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"snapshot_id"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetSnapshotResponseFromJSON(jsonValue));
    }
    /**
     */
    async getSnapshot(locationOrganizationId, locationProjectId, snapshotId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getSnapshotRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, snapshotId: snapshotId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getUtilizationRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getUtilization.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getUtilization.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling getUtilization.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/utilization`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125GetUtilizationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUtilization(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.getUtilizationRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async isVaultPluginRegisteredRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling isVaultPluginRegistered.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling isVaultPluginRegistered.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling isVaultPluginRegistered.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling isVaultPluginRegistered.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/plugin/is-registered`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125IsVaultPluginRegisteredRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125IsVaultPluginRegisteredResponseFromJSON(jsonValue));
    }
    /**
     */
    async isVaultPluginRegistered(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.isVaultPluginRegisteredRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async listRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling list.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling list.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.filtersPrimariesOnly !== undefined) {
            queryParameters['filters.primaries_only'] = requestParameters.filtersPrimariesOnly;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125ListResponseFromJSON(jsonValue));
    }
    /**
     */
    async list(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, filtersPrimariesOnly) {
        const response = await this.listRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, filtersPrimariesOnly: filtersPrimariesOnly });
        return await response.value();
    }
    /**
     */
    async listAllClustersRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listAllClusters.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listAllClusters.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.filtersPrimariesOnly !== undefined) {
            queryParameters['filters.primaries_only'] = requestParameters.filtersPrimariesOnly;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/vault-clusters`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125ListAllClustersResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAllClusters(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, filtersPrimariesOnly) {
        const response = await this.listAllClustersRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, filtersPrimariesOnly: filtersPrimariesOnly });
        return await response.value();
    }
    /**
     */
    async listPerformanceReplicationSecondariesRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listPerformanceReplicationSecondaries.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listPerformanceReplicationSecondaries.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling listPerformanceReplicationSecondaries.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/list-performance-replication-secondaries`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125ListPerformanceReplicationSecondariesResponseFromJSON(jsonValue));
    }
    /**
     */
    async listPerformanceReplicationSecondaries(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listPerformanceReplicationSecondariesRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listSnapshotsRaw(requestParameters) {
        if (requestParameters.resourceLocationOrganizationId === null || requestParameters.resourceLocationOrganizationId === undefined) {
            throw new runtime.RequiredError('resourceLocationOrganizationId', 'Required parameter requestParameters.resourceLocationOrganizationId was null or undefined when calling listSnapshots.');
        }
        if (requestParameters.resourceLocationProjectId === null || requestParameters.resourceLocationProjectId === undefined) {
            throw new runtime.RequiredError('resourceLocationProjectId', 'Required parameter requestParameters.resourceLocationProjectId was null or undefined when calling listSnapshots.');
        }
        const queryParameters = {};
        if (requestParameters.resourceType !== undefined) {
            queryParameters['resource.type'] = requestParameters.resourceType;
        }
        if (requestParameters.resourceUuid !== undefined) {
            queryParameters['resource.uuid'] = requestParameters.resourceUuid;
        }
        if (requestParameters.resourceLocationRegionProvider !== undefined) {
            queryParameters['resource.location.region.provider'] = requestParameters.resourceLocationRegionProvider;
        }
        if (requestParameters.resourceLocationRegionRegion !== undefined) {
            queryParameters['resource.location.region.region'] = requestParameters.resourceLocationRegionRegion;
        }
        if (requestParameters.resourceDescription !== undefined) {
            queryParameters['resource.description'] = requestParameters.resourceDescription;
        }
        if (requestParameters.resourceId !== undefined) {
            queryParameters['resource.id'] = requestParameters.resourceId;
        }
        if (requestParameters.resourceInternalId !== undefined) {
            queryParameters['resource.internal_id'] = requestParameters.resourceInternalId;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{resource.location.organization_id}/projects/{resource.location.project_id}/snapshots`.replace(`{${"resource.location.organization_id"}}`, encodeURIComponent(String(requestParameters.resourceLocationOrganizationId))).replace(`{${"resource.location.project_id"}}`, encodeURIComponent(String(requestParameters.resourceLocationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125ListSnapshotsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listSnapshots(resourceLocationOrganizationId, resourceLocationProjectId, resourceType, resourceUuid, resourceLocationRegionProvider, resourceLocationRegionRegion, resourceDescription, resourceId, resourceInternalId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listSnapshotsRaw({ resourceLocationOrganizationId: resourceLocationOrganizationId, resourceLocationProjectId: resourceLocationProjectId, resourceType: resourceType, resourceUuid: resourceUuid, resourceLocationRegionProvider: resourceLocationRegionProvider, resourceLocationRegionRegion: resourceLocationRegionRegion, resourceDescription: resourceDescription, resourceId: resourceId, resourceInternalId: resourceInternalId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async lockRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling lock.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling lock.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling lock.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling lock.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/lock`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125LockRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125LockResponseFromJSON(jsonValue));
    }
    /**
     */
    async lock(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.lockRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async pluginRegistrationStatusRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling pluginRegistrationStatus.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling pluginRegistrationStatus.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling pluginRegistrationStatus.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/plugin/registration-status`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125PluginRegistrationStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async pluginRegistrationStatus(locationOrganizationId, locationProjectId, clusterId, locationRegionProvider, locationRegionRegion) {
        const response = await this.pluginRegistrationStatusRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async recreateFromSnapshotRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling recreateFromSnapshot.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling recreateFromSnapshot.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling recreateFromSnapshot.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling recreateFromSnapshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/recreatefromsnapshot`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125RecreateFromSnapshotRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125RecreateFromSnapshotResponseFromJSON(jsonValue));
    }
    /**
     */
    async recreateFromSnapshot(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.recreateFromSnapshotRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async registerLinkedClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling registerLinkedCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling registerLinkedCluster.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling registerLinkedCluster.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/link/register`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125RegisterLinkedClusterRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125RegisterLinkedClusterResponseFromJSON(jsonValue));
    }
    /**
     */
    async registerLinkedCluster(locationOrganizationId, locationProjectId, body) {
        const response = await this.registerLinkedClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, body: body });
        return await response.value();
    }
    /**
     */
    async restoreSnapshotRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling restoreSnapshot.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling restoreSnapshot.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling restoreSnapshot.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling restoreSnapshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/restore`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125RestoreSnapshotRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125RestoreSnapshotResponseFromJSON(jsonValue));
    }
    /**
     */
    async restoreSnapshot(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.restoreSnapshotRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async revokeAdminTokensRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling revokeAdminTokens.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling revokeAdminTokens.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling revokeAdminTokens.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling revokeAdminTokens.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/revoke-admin-tokens`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125RevokeAdminTokensRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async revokeAdminTokens(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.revokeAdminTokensRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async sealRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling seal.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling seal.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling seal.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling seal.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/seal`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125SealRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125SealResponseFromJSON(jsonValue));
    }
    /**
     */
    async seal(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.sealRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async unlockRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling unlock.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling unlock.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling unlock.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling unlock.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/unlock`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UnlockRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UnlockResponseFromJSON(jsonValue));
    }
    /**
     */
    async unlock(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.unlockRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async unsealRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling unseal.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling unseal.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling unseal.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling unseal.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/unseal`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UnsealRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UnsealResponseFromJSON(jsonValue));
    }
    /**
     */
    async unseal(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.unsealRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async updateRaw(requestParameters) {
        if (requestParameters.clusterLocationOrganizationId === null || requestParameters.clusterLocationOrganizationId === undefined) {
            throw new runtime.RequiredError('clusterLocationOrganizationId', 'Required parameter requestParameters.clusterLocationOrganizationId was null or undefined when calling update.');
        }
        if (requestParameters.clusterLocationProjectId === null || requestParameters.clusterLocationProjectId === undefined) {
            throw new runtime.RequiredError('clusterLocationProjectId', 'Required parameter requestParameters.clusterLocationProjectId was null or undefined when calling update.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling update.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling update.');
        }
        const queryParameters = {};
        if (requestParameters.updateMaskPaths) {
            queryParameters['update_mask.paths'] = requestParameters.updateMaskPaths;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{cluster.location.organization_id}/projects/{cluster.location.project_id}/clusters/{cluster.id}`.replace(`{${"cluster.location.organization_id"}}`, encodeURIComponent(String(requestParameters.clusterLocationOrganizationId))).replace(`{${"cluster.location.project_id"}}`, encodeURIComponent(String(requestParameters.clusterLocationProjectId))).replace(`{${"cluster.id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125InputClusterToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UpdateResponseFromJSON(jsonValue));
    }
    /**
     */
    async update(clusterLocationOrganizationId, clusterLocationProjectId, clusterId, body, updateMaskPaths) {
        const response = await this.updateRaw({ clusterLocationOrganizationId: clusterLocationOrganizationId, clusterLocationProjectId: clusterLocationProjectId, clusterId: clusterId, body: body, updateMaskPaths: updateMaskPaths });
        return await response.value();
    }
    /**
     */
    async updateCORSConfigRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling updateCORSConfig.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling updateCORSConfig.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling updateCORSConfig.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateCORSConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/update-cors-config`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpdateCORSConfigRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateCORSConfig(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.updateCORSConfigRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async updateMajorVersionUpgradeConfigRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling updateMajorVersionUpgradeConfig.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling updateMajorVersionUpgradeConfig.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling updateMajorVersionUpgradeConfig.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateMajorVersionUpgradeConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/major-version-upgrade-config/update`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpdateMajorVersionUpgradeConfigRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateMajorVersionUpgradeConfig(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.updateMajorVersionUpgradeConfigRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async updatePathsFilterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling updatePathsFilter.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling updatePathsFilter.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling updatePathsFilter.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updatePathsFilter.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/paths-filter/update`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpdatePathsFilterRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UpdatePathsFilterResponseFromJSON(jsonValue));
    }
    /**
     */
    async updatePathsFilter(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.updatePathsFilterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async updatePublicIpsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling updatePublicIps.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling updatePublicIps.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling updatePublicIps.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updatePublicIps.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/public-ips`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpdatePublicIpsRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UpdatePublicIpsResponseFromJSON(jsonValue));
    }
    /**
     */
    async updatePublicIps(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.updatePublicIpsRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
    /**
     */
    async updateSnapshotRaw(requestParameters) {
        if (requestParameters.snapshotLocationOrganizationId === null || requestParameters.snapshotLocationOrganizationId === undefined) {
            throw new runtime.RequiredError('snapshotLocationOrganizationId', 'Required parameter requestParameters.snapshotLocationOrganizationId was null or undefined when calling updateSnapshot.');
        }
        if (requestParameters.snapshotLocationProjectId === null || requestParameters.snapshotLocationProjectId === undefined) {
            throw new runtime.RequiredError('snapshotLocationProjectId', 'Required parameter requestParameters.snapshotLocationProjectId was null or undefined when calling updateSnapshot.');
        }
        if (requestParameters.snapshotSnapshotId === null || requestParameters.snapshotSnapshotId === undefined) {
            throw new runtime.RequiredError('snapshotSnapshotId', 'Required parameter requestParameters.snapshotSnapshotId was null or undefined when calling updateSnapshot.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateSnapshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{snapshot.location.organization_id}/projects/{snapshot.location.project_id}/snapshots/{snapshot.snapshot_id}`.replace(`{${"snapshot.location.organization_id"}}`, encodeURIComponent(String(requestParameters.snapshotLocationOrganizationId))).replace(`{${"snapshot.location.project_id"}}`, encodeURIComponent(String(requestParameters.snapshotLocationProjectId))).replace(`{${"snapshot.snapshot_id"}}`, encodeURIComponent(String(requestParameters.snapshotSnapshotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpdateSnapshotRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UpdateSnapshotResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateSnapshot(snapshotLocationOrganizationId, snapshotLocationProjectId, snapshotSnapshotId, body) {
        const response = await this.updateSnapshotRaw({ snapshotLocationOrganizationId: snapshotLocationOrganizationId, snapshotLocationProjectId: snapshotLocationProjectId, snapshotSnapshotId: snapshotSnapshotId, body: body });
        return await response.value();
    }
    /**
     */
    async updateVersionRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling updateVersion.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling updateVersion.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling updateVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling updateVersion.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/{version}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpdateVersionRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UpdateVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateVersion(locationOrganizationId, locationProjectId, clusterId, version, body) {
        const response = await this.updateVersionRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, version: version, body: body });
        return await response.value();
    }
    /**
     */
    async upgradeMajorVersionRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling upgradeMajorVersion.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling upgradeMajorVersion.');
        }
        if (requestParameters.clusterId === null || requestParameters.clusterId === undefined) {
            throw new runtime.RequiredError('clusterId', 'Required parameter requestParameters.clusterId was null or undefined when calling upgradeMajorVersion.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling upgradeMajorVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }
        const response = await this.request({
            path: `/vault/2020-11-25/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{cluster_id}/major-version/upgrade`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters.clusterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVault20201125UpgradeMajorVersionRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVault20201125UpgradeMajorVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async upgradeMajorVersion(locationOrganizationId, locationProjectId, clusterId, body) {
        const response = await this.upgradeMajorVersionRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, clusterId: clusterId, body: body });
        return await response.value();
    }
}
